import * as focusTrap from 'focus-trap'

export default class SurveyModal {
  ready () {
    this.SURVEY_MODAL = document.querySelector('#survey-modal')
    this.DECLINE_BUTTON = document.querySelector('#survey-modal-decline')
    this.CLOSE_BUTTON = document.querySelector('#survey-modal-close')
    this.FOCUS_TRAP = undefined

    if (this.SURVEY_MODAL) {
      if (window.Cookiebot) {
        const handleStatisticsConsent = () => {
          if (window.Cookiebot?.consent?.statistics) {
            this.SURVEY_MODAL.classList.add('mtt-survey-modal-wrapper--active')
            this.initFocusTrap()
          }
        }

        window.addEventListener('CookiebotOnConsentReady', handleStatisticsConsent)
        window.addEventListener('CookiebotOnAccept', handleStatisticsConsent)
      } else {
        this.SURVEY_MODAL.classList.add('mtt-survey-modal-wrapper--active')
        this.initFocusTrap()
      }

      jQuery(document).on('gform_confirmation_loaded', (event, formId) => {
        if (formId === 1) {
          this.setCookie('lego_survey_modal_closed', 'true', 0)
        }
      })

      // Lock body scroll when the modal is open
      this.lockBodyScroll()

      // Close the modal when the decline button is clicked
      if (this.DECLINE_BUTTON) {
        this.DECLINE_BUTTON.addEventListener('click', () => {
          this.closeModal()
        })
      }

      // Close the modal when the close button is clicked
      if (this.CLOSE_BUTTON) {
        this.CLOSE_BUTTON.addEventListener('click', () => {
          this.closeModal()
        })
      }
    }
  }

  initFocusTrap () {
    this.FOCUS_TRAP = focusTrap.createFocusTrap(this.SURVEY_MODAL, {
      escapeDeactivates: false,
    })

    this.FOCUS_TRAP.activate()
  }

  lockBodyScroll () {
    document.body.style.overflow = 'hidden'
  }

  unlockBodyScroll () {
    document.body.style.overflow = ''
  }

  setCookie (name, value, days) {
    let expires
    if (typeof days === 'undefined' || days === 0) {
      // Never expire: set to a far future date
      expires = '; expires=Fri, 01 Jan 2099 00:00:00 GMT'
    } else {
      expires = `; expires=${new Date(Date.now() + days * 864e5).toUTCString()}`
    }
    document.cookie = `${name}=${encodeURIComponent(value || '')}${expires}; path=/`
  }

  closeModal () {
    this.setCookie('lego_survey_modal_closed', 'true', 0)
    this.unlockBodyScroll()
    this.SURVEY_MODAL.remove()
    this.FOCUS_TRAP?.deactivate()
  }
}
